import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import Colors from '../../../assets/Colors';
import CloseIcon from '../../icons/CloseIcon';
import s from './styles';

function FormHeader({
  closeModal,
  onSave,
  enabled,
  updating,
  addTitle,
  updateTitle,
  saving,
  reset,
}) {
  const { t } = useTranslation();
  return (
    <s.Header>
      <s.HeaderTopItems>
        <s.IconContainer
          onClick={() => {
            closeModal();
            if (reset) reset();
          }}
        >
          <CloseIcon size={13} color={Colors.primary} />
        </s.IconContainer>
        <s.TitleContainer>
          {!updating ? addTitle : updateTitle}
        </s.TitleContainer>
        <Button
          loading={saving}
          style={{
            fontSize: '15px',
            fontWeight: '500',
          }}
          type="text"
          onClick={enabled ? onSave : undefined}
          disabled={!enabled}
        >
          {t('components.CustomerList.AddCustomer.Header.save')}
        </Button>
      </s.HeaderTopItems>
    </s.Header>
  );
}

export default FormHeader;
